export enum CampaignTypes {
  announcements_type = 'announcements_type',
  get_subscribers_type = 'get_subscribers_type',
  limited_offer_type = 'limited_offer_type',
}
